import React, { useState, useEffect } from "react";
import BadgeImage from "../../Components/Badges";

import calendarVector from "../../../Asset/Events/calendar-vector.svg";
import locationVector from "../../../Asset/Events/location-vector.svg";
import timeVector from "../../../Asset/Events/time-vector.svg";
import coinVector from "../../../Asset/Events/coin-vector.svg";
import ShowSponsors from "../EventComponents/ShowSponsors";
import "./MoreEventCard.css"
import { format } from "date-fns";
import { Link } from 'react-router-dom';
import Axios from "axios";
import ReactMarkdown from 'react-markdown'
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { formatPrice } from "../../utils/price";

const MoreEventCard = ({ eventData, showTitle = true, sliceTill }) => {
  const BadgeSize = { width: "19rem", height: "19rem" };
  const [eventImages, setEventImages] = useState([]);
  const [eventImagesMobile, setEventImagesMobile] = useState([]);
  const [sortedEventData, setSortedEventData] = useState([])
  const [isMobile, setIsMobile] = useState(false)
  // Check for mobile device using media query
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1024px)");
    setIsMobile(mediaQuery.matches);


    // Add event listener for screen resizing
    const handleResize = () => setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleResize);

    // Cleanup the event listener
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  useEffect(() => {
    // Sort eventData by StartTimeStamp whenever it updates
    if (eventData?.length > 0) {
      const sorted = [...eventData].sort((a, b) =>
        new Date(a.EventSchedule.StartTimeStamp) - new Date(b.EventSchedule.StartTimeStamp)
      );
      setSortedEventData(sorted);
    }
  }, [eventData]);



  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Use Promise.all to fetch images for all events in parallel
        const imagePromises = eventData.map(async (event) => {
          try {


            if (!event.EventImages || event.EventImages.length === 0) {
              console.error("No images available for event", event.EventId);
              return {
                eventId: event.EventId,
                tallImageUrl: "",
                wideImageUrl: "",
              };
            }

            // Find tall and wide images
            const tallImage = event.EventImages.find((image) =>
              image.Tags.includes("TALL")
            );



            const wideImage = event.EventImages.find((image) =>
              image.Tags.includes("WIDE")
            );


            const tallImageFileId = tallImage?.FileId || null;
            const wideImageFileId = wideImage?.FileId || null;

            // If either image is missing, log an error and return default
            if (!tallImageFileId) {
              console.error("No tall image found for event", event.EventId);
            }
            if (!wideImageFileId) {
              console.error("No wide image found for event", event.EventId);
            }

            // Fetch the images if IDs exist

            if (isMobile === true) {
              const wideImageRes =
                wideImageFileId &&
                (await Axios.get(
                  `${process.env.REACT_APP_BASE_URL}/files/${wideImageFileId}/download`,
                  { responseType: "blob" }
                ));


              const wideImageUrl = wideImageRes
                ? URL.createObjectURL(wideImageRes.data)
                : "";
              return {
                eventId: event.EventId,

                wideImageUrl

              };
            }

            else {
              const tallImageRes =
                tallImageFileId &&
                (await Axios.get(
                  `${process.env.REACT_APP_BASE_URL}/files/${tallImageFileId}/download`,
                  { responseType: "blob" }
                ));
              const tallImageUrl = tallImageRes
                ? URL.createObjectURL(tallImageRes.data)
                : "";
              return {
                eventId: event.EventId,
                tallImageUrl
              };
            }

          } catch (error) {
            console.error("Error fetching images for event", event.EventId, error);
            return {
              eventId: event.EventId,
              tallImageUrl: "",
              wideImageUrl: "",
            };
          }
        });

        // Wait for all image fetches to complete
        const images = await Promise.all(imagePromises);

        // Separate tall and wide images for their respective states
        const tallImages = images.map(({ eventId, tallImageUrl }) => ({
          eventId,
          tallImageUrl: tallImageUrl,
        }));

        const wideImages = images.map(({ eventId, wideImageUrl }) => ({
          eventId,
          wideImageUrl: wideImageUrl,
        }));

        // Update the states
        setEventImages(tallImages); // For tall images
        setEventImagesMobile(wideImages); // For wide images
      } catch (globalError) {
        console.error("Error in fetchImages function", globalError);
      }
    };

    if (eventData && eventData.length > 0) {
      fetchImages();
    }
  }, [eventData, setEventImages, setEventImagesMobile, isMobile]);


  // Ensure eventData exists and has MoreEvents array
  if (!eventData || eventData.length === 0) {
    return null; // Return nothing if no data is present
  }

  return (
    <>
      <div className="moreEvents-container flex flex-col justify-center items-center  ">
        {showTitle && <h1 className="text-[var(--dark-blue)] text-3xl lg:text-[2rem] font-medium w-[100%] lg:pl-12 lg:mb-5 font-ClashGrotesk pl-5 mb-5">More Events</h1>}
        {sortedEventData.slice(0, sliceTill).map((moreevents) => {
          // Find the image URL for the current event
          const tallEventImage = eventImages.find((img) => img.eventId === moreevents.EventId)?.tallImageUrl || "";


          const wideEventImage = eventImagesMobile.find((img) => img.eventId === moreevents.EventId)?.wideImageUrl || "";



          return (
            <div className={`w-full ${!showTitle ? 'flex justify-center' : ''} `} key={moreevents.EventId}>


              {/* Card 1 Container */}
              <div className={`card1 mb-12 flex flex-col  justify-center items-start w-[93%] lg:w-[92%] rounded-3xl  mx-auto lg:mx-0 relative ${!showTitle ? '' : ' lg:ml-12'} `}>

                <div id="moreEvent-card-sponsors" className={` w-full flex flex-wrap justify-start items-center ${moreevents?.sponsors?.length > 0 ? 'h-22 lg:h-28' : 'h-4 lg:h-12'}`}>
                  {moreevents?.sponsors?.length > 0 && (
                    <div id="moreEvents-card-sponsors" className="flex flex-col lg:flex-row items-start lg:items-center justify-center lg:justify-start pt-6  lg:pt-3  lg:pl-14 pl-6 lg:gap-10 lg:w-[64%]">
                      <div className="text-[var(--purple-blue)] text-base font-manrope font-semibold">Sponsors</div>
                      <span className="hidden lg:block text-4xl text-[var(--purple-blue)] font-ClashGrotesk font-extralight">|</span>
                      <div className=" w-full   lg:-ml-10 mt-4 lg:mt-0">
                        <ShowSponsors eventData={moreevents} />
                      </div>

                    </div>
                  )}
                </div>

                {/* containing content of card */}
                <div id="moreEvents-card-content" className=" flex flex-col lg:flex-row justify-center lg:justify-between items-center w-[100%] lg:w-[100%] rounded-3xl  lg:mx-0 ">

                  {/* Inside container left part */}
                  <div className="flex flex-col lg:flex-row lg:w-[64%] items-center lg:justify-start lg:items-start lg:pr-10 lg:pl-14 lg:pb-10 px-3 pb-3 lg:gap-4 w-full ">
                    {/* Image */}
                    <div id="moreEvents-image-container" className="block lg:hidden w-full  p-3 ">
                      {wideEventImage ? (
                        <img src={wideEventImage} alt={moreevents.EventTitle} className="w-full  h-full rounded-2xl" />
                      ) : ""}
                    </div>
                    <div className="hidden lg:block lg:w-[35%]">
                      {tallEventImage ? (
                        <img className="w-full mt-1 rounded-[1.3rem]" src={tallEventImage} alt={moreevents.EventTitle} />
                      ) : ""}
                    </div>

                    {/* Text part */}
                    <div id="moreEvents-text-part" className="flex flex-col lg:gap-5 lg:mb-auto justify-between lg:justify-start w-[94%] lg:w-[80%] text-[var(--medium-purple)] lg:pl-6 overflow-hidden">
                      <div className="flex">
                        {/* Heading */}
                        <div className="w-3/5 lg:w-full">
                          <h1 className="xl:text-[3.25rem] lg:leading-[3.25rem] lg:text-3xl text-2xl font-manrope font-semibold py-2 pt-3 lg:pt-0">
                            {moreevents.EventTitle}
                          </h1>
                        </div>

                        {/* Badge image for Mobile */}
                        <div className={`lg:hidden w-[35%] sm:w-[28%] md:w-[25%] ml-0 absolute right-2  ${moreevents?.sponsors?.length > 0 ? 'top-[19rem]  md:top-[32rem]' : 'top-[14rem] md:top-[27rem]'}`}>
                          <BadgeImage EventType={moreevents.EventType} size={BadgeSize} />
                        </div>
                      </div>
                      <div className="pb-5 pt-7 lg:pt-0 lg:pb-0 overflow-hidden">
                        <p id="scroll-container" className=" font-ClashGrotesk font-medium lg:w-[88%]   max-h-20 lg:max-h-24 overflow-y-auto"
                        //  dangerouslySetInnerHTML={{ __html: marked(moreevents.EventDescription) }}
                        >
                          <ReactMarkdown
                            children={
                              moreevents.EventDescription || "No description provided."
                            }
                            remarkPlugins={[remarkGfm]}
                            rehypePlugins={[rehypeRaw]}
                            components={{
                              a: ({ children, href }) => (
                                <a href={href} className="hover:text-blue-500 underline">
                                  {children}
                                </a>
                              ),
                              ul: ({ children }) => (
                                <ul className="list-disc pl-5">{children}</ul>
                              ),
                              ol: ({ children }) => (
                                <ol className="list-decimal pl-5" >{children}</ol>
                              ),
                            }}
                          />
                        </p>


                      </div>

                      <hr className="border border-[var(--medium-purple)] border-solid mb-4 lg:w-[85%]" />

                      {/* Inside partition */}
                      <div className="flex pb-2 text-base w-full lg:-mt-5 lg:text-base font-manrope font-semibold text-[var(--gray-black)] lg:gap-x-5 ">
                        <span className="flex gap-1 gap-x-2 w-full lg:w-fit whitespace-nowrap">
                          <span className="flex-shrink-0" > <img src={calendarVector} alt="calendar vector" />
                          </span>
                          {format(new Date(moreevents.EventSchedule.StartTimeStamp), "do MMMM")
                            + (format(new Date(moreevents.EventSchedule.EndTimeStamp), "do MMMM") > format(new Date(moreevents.EventSchedule.StartTimeStamp), "do MMMM") ?
                              ` - ${format(new Date(moreevents.EventSchedule.EndTimeStamp), "do MMMM")}`
                              :
                              '')}
                        </span>
                        <span className="flex flex-grow gap-1 w-full lg:w-fit whitespace-nowrap">
                          <span className="flex-shrink-0"> <img src={timeVector} alt="clock vector" /></span>
                          <span className="whitespace-nowrap">
                            <div className="inline-block">{format(new Date(moreevents.EventSchedule.StartTimeStamp), "h:mm a")}</div>
                            <div className="inline-block">-</div>
                            <div className="inline-block">{format(new Date(moreevents.EventSchedule.EndTimeStamp), "h:mm a")}</div>

                          </span>
                        </span>
                      </div>
                      <div className="flex pb-2 lg:-mt-4 lg:text-base font-manrope font-semibold text-[var(--gray-black)] lg:gap-x-5 ">
                        <span className="flex gap-1 w-full lg:w-fit whitespace-nowrap">
                          <span className="flex-shrink-0"><img src={locationVector} alt="location vector" /></span>  {moreevents?.venue?.VenueName}{", "}{moreevents?.venue?.VenueAddress?.city}
                        </span>
                        <span className="flex flex-grow  gap-1 w-full lg:w-fit whitespace-nowrap">
                          <span className="flex-shrink-0"> <img src={coinVector} alt="coin vector" /></span> ₹{formatPrice(moreevents.Price_Before_GST ?? 0)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Inside container right part */}
                  <div className="flex flex-col justify-between lg:items-end items-center lg:w-[37%] lg:gap-14 gap-2 p-4 lg:mr-5">
                    <div className={`${moreevents?.sponsors?.length > 0 ? 'lg:-mt-[10rem] lg:-mr-10 hidden lg:block' : 'lg:-mt-[5rem] lg:-mr-10 hidden lg:block'} `}>
                      <BadgeImage EventType={moreevents.EventType} size={BadgeSize} />
                    </div>

                    {/* Register Button */}
                    <Link to={`/events/${moreevents.EventId}`} >
                      <button className={`border-solid border-2 border-[var(--medium-purple)] text-[var(--purple-blue)] text-lg  ${moreevents.isRegistrationOpen ? (moreevents.isFull ? 'lg:px-28 px-24' : 'lg:px-32 px-32') : 'lg:px-20 px-16'} py-[0.75rem] rounded-xl lg:mr-4 font-medium font-manrope text-[1.1rem] cursor-pointer mt-12 mb-8 lg:mt-0 lg:mb-0`}>
                        {moreevents.isRegistrationOpen ?
                          (moreevents.isFull ? ('Join Waitlist') :
                            ('Register')) : ('Registration Closed')}

                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default MoreEventCard;
